// Pure rules for the catalog form. No `@/…` imports so this module runs under
// `node --experimental-strip-types`.

export interface AdditionalPortInput {
  port: number;
  prefix: string;
}

// Same rule as the server (handlers/catalog.go validateAdditionalPorts).
const PREFIX_RE = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/;
export const MAX_PREFIX_LENGTH = 15;

/** One message per row (undefined = valid), in row order. */
export function additionalPortErrors(ports: AdditionalPortInput[]): (string | undefined)[] {
  const seen = new Set<string>();
  return ports.map(({ port, prefix }) => {
    let msg: string | undefined;
    if (!Number.isInteger(port) || port < 1 || port > 65535) {
      msg = 'Port must be between 1 and 65535.';
    } else if (prefix.length > MAX_PREFIX_LENGTH || !PREFIX_RE.test(prefix)) {
      msg = `Prefix: 1-${MAX_PREFIX_LENGTH} lowercase letters, digits or "-", not at the start or end.`;
    } else if (seen.has(prefix)) {
      msg = 'Prefix is already used by another port.';
    }
    seen.add(prefix);
    return msg;
  });
}
